import UserEducationEdit from '@/components/user/tab/education/edit/UserEducationEdit.vue';

export default {
  name: 'UserEducation',

  props: {
    userApiId: {
      type: String,
      default: null
    }
  },

  components: {
    UserEducationEdit
  },

  data () {
    return {
      educationList: [],
      currentReq: null,
      isLoading: false,
      paging: { limit: 10, page: 1, total: 0, pages: 0 }
    }
  },

  computed: {
    tableHeaders () {
      const headers = [
        { key: 'level_id', label: this.$t('user.table.education-level'), format: 'formatFunc', funcs: [this.getLevelName] },
        { key: 'place_id', label: this.$t('user.table.education-place'), format: 'formatFunc', funcs: [this.getPlaceName] },
        { key: 'type_id', label: this.$t('user.table.education-type'), format: 'formatFunc', funcs: [this.getTypeName] },
        { key: 'specialty_id', label: this.$t('user.table.education-specialty'), format: 'formatFunc', funcs: [this.getSpecialtyName] },
        { key: 'document', label: this.$t('user.table.document') },
        { key: 'documentNo', label: this.$t('user.table.document-no') },
        { key: 'startYear', label: this.$t('user.table.start-year') },
        { key: 'endYear', label: this.$t('user.table.end-year') },
        { key: 'isDocumentPresented', label: this.$t('user.table.document-presented'), format: 'formatYesNo' }
      ];

      let actions = [];
      if (this.canEdit) {
        actions = [
          { label: this.$t('user.education.btn.title-edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-warning btn-sm' },
          { label: this.$t('user.education.btn.title-delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-danger btn-sm' }
        ];
      }

      headers.push({ key: 'actions', label: '', actions: actions, headerClass: 'col-1' });
      return headers;
    },

    canEdit () {
      return this.ApiRequest.userHasPermission('edit-all-users');
    }
  },

  methods: {
    populateEducation () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }

      this.isLoading = true;
      const path = `user/education/list?userApi_id=${this.userApiId}&perPage=${this.paging.limit}&page=${this.paging.page}`;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          this.educationList = response.data;
          this.paging = response.paging;
        }
        this.isLoading = false;
      });
    },

    getLevelName (id) {
      return id ? this.$store.getters.getParamFromConfig('education_levels', id, 'name', this.$i18n.locale) : null;
    },

    getPlaceName (id) {
      return id ? this.$store.getters.getParamFromConfig('education_places', id, 'name', this.$i18n.locale) : null;
    },

    getTypeName (id) {
      return id ? this.$store.getters.getParamFromConfig('education_types', id, 'name', this.$i18n.locale) : null;
    },

    getSpecialtyName (id) {
      return id ? this.$store.getters.getParamFromConfig('education_specialities', id, 'name', this.$i18n.locale) : null;
    },

    editItem (el) {
      this.$refs.editUserEducation.show(el ? el.id : 'NEW', this.userApiId);
    },

    changePage (pageNr) {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }

      this.paging.page = pageNr;
      this.populateEducation();
    },

    async deleteItem (el, approved) {
      if (approved) {
        const { data } = await this.destroy(`user/education/destroy/${el.id}`);
        if (data) {
          this.$store.commit('toastAdd', { context: 'success', message: this.$t('user.education.delete_successfully', { place: el.place }) });
        }
        this.populateEducation();
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('user.education.title-delete'), this.$t('user.education.text-delete', { place: el.place }))
      }
    },

    async destroy (path) {
      try {
        return new Promise((resolve, reject) => {
          this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, this.form, response => {
            if (response.error) {
              this.isLoading = false;
              this.ApiRequest.displayErrorDialog(response, this);
              reject(response.error);
            }
            resolve(response);
          });
        });
      } catch (e) {
        console.error(e);
      }
    }
  },

  mounted () {
    this.populateEducation();
  }
}
